
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/comparison",
      function () {
        return require("private-next-pages/product/comparison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/comparison"])
      });
    }
  